import { metaObject } from "@/config/site.config";
import { Client, RegisterClient } from "@/types";
import { useState, useEffect } from "react";
import ClientPageHeader from "./page-header";
import toast from "react-hot-toast";
import ClientsListTable from "@/app/shared/clients/list/table";
import { CreateClient, fetchClients } from "@/server/api-services";

export const metadata = {
    ...metaObject("Logistics"),
};

export default function ClientListPage() {
    const [clients, setClients] = useState<Client[]>([]);

    useEffect(() => {
        loadClients();
    }, []);

    async function loadClients() {
        const response = await fetchClients();

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Client[];


        setClients(data);
    }

    const refresh = () => loadClients();

    return (
        <>
            <ClientPageHeader
                title="Clients"
                clients={clients}
            />
            <div className="flex flex-col gap-10">
                <ClientsListTable clients={clients} refresh={refresh} />
            </div>
        </>
    );
}
